import Axios from "axios";
import { logUserAction } from "../../helpers/user-tracking";
import {
  ADD_TO_BOOKMARK,
  FETCH_BOOKMARKS_REQUEST,
  FETCH_BOOKMARKS_SUCCESS,
  FETCH_BOOKMARKS_FAILURE,
  ADD_BOOKMARK_REQUEST,
  ADD_BOOKMARK_SUCCESS,
  ADD_BOOKMARK_FAILURE,
  DELETE_BOOKMARK_REQUEST,
  DELETE_BOOKMARK_SUCCESS,
  DELETE_BOOKMARK_FAILURE,
  CLEAR_BOOKMARKS,
} from "../types/bookmarkTypes";

const API_BASE_URL = "https://cms.vidhaantextiles.com/api";

// Fetch bookmarks from backend API
export const fetchBookmarks = (page=1) => {
  console.log('in fetch bookmarks',page);
  
  return async (dispatch) => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.log("No token found, skipping bookmark fetch");
      return;
    }

    dispatch({ type: FETCH_BOOKMARKS_REQUEST });

    try {
      const response = await Axios.get(
        `${API_BASE_URL}/bookmarks?populate[fabric][populate][image]=true&populate[fabric][populate][primary_image]=true&populate[fabric][populate][mill]=true&populate[fabric][populate][width]=true&populate[knit][populate][image]=true&populate[knit][populate][primary_image]=true&populate[knit][populate][mill]=true&populate[knit][populate][width]=true&populate[stock][populate][image]=true&populate[stock][populate][primary_image]=true&populate[stock][populate][mill]=true&populate[stock][populate][width]=true&pagination[page]=${page}&pagination[pageSize]=100&sort=id:desc`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: FETCH_BOOKMARKS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error fetching bookmarks:", error);
      dispatch({
        type: FETCH_BOOKMARKS_FAILURE,
        payload: error.message,
      });
    }
  };
};

// Add bookmark via backend API
export const addToBookmark = (product, addToast) => {
  return async (dispatch, getState) => {
    const token = localStorage.getItem("token");

    if (!token) {
      if (addToast) {
        addToast("Please login to bookmark items", {
          appearance: "warning",
          autoDismiss: true,
        });
      }
      return;
    }

    // Check if already bookmarked
    const { bookmarkData } = getState();
    const existingBookmark = bookmarkData.bookmarkItems.find(
      (item) => item.id === product.id
    );

    if (existingBookmark) {
      if (addToast) {
        addToast("Already bookmarked", {
          appearance: "info",
          autoDismiss: true,
        });
      }
      return;
    }

    dispatch({ type: ADD_BOOKMARK_REQUEST });

    let finalItemType = "fabric";
    let finalKey = "fabric";

    const viewMode = localStorage.getItem("viewMode");
    const categoryName = localStorage.getItem("category");
    const isKnitsMode = localStorage.getItem("isKnitsMode");

    if (viewMode === "stocks" || window.location.pathname.includes("/stocks")) {
      finalItemType = "stock";
      finalKey = "stock";
    } else if (categoryName === "knits" || isKnitsMode === "true" || window.location.pathname.includes("/knits")) {
      finalItemType = "knit";
      finalKey = "knit";
    }

    const requestData = {
      itemType: finalItemType,
      [finalKey]: product.id
    };

    logUserAction("bookmarked", product.id, finalItemType);

    try {
      const response = await Axios.post(
        `${API_BASE_URL}/bookmarks`,
        {
          data: requestData,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // After successful API call, add to local state
      // Transform the product to match the expected structure
      dispatch({
        type: ADD_BOOKMARK_SUCCESS,
        payload: {
          bookmarkId: response.data.data.id,
          product: product,
          itemType: finalItemType,
        },
      });

      // Refetch bookmarks to update the count across the application
      dispatch(fetchBookmarks(1));

      if (addToast) {
        addToast("Added to bookmarks", {
          appearance: "success",
          autoDismiss: true,
        });
      }
    } catch (error) {
      console.error("Error adding bookmark:", error);
      dispatch({
        type: ADD_BOOKMARK_FAILURE,
        payload: error.message,
      });

      if (addToast) {
        addToast("Failed to add bookmark", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    }
  };
};

export const deleteFromBookmark = (bookmarkId, addToast) => {
  return async (dispatch, getState) => {
    const token = localStorage.getItem("token");

    if (!token) {
      if (addToast) {
        addToast("Please login", {
          appearance: "warning",
          autoDismiss: true,
        });
      }
      return;
    }

    dispatch({ type: DELETE_BOOKMARK_REQUEST });

    try {
      await Axios.delete(`${API_BASE_URL}/bookmarks/${bookmarkId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({ type: DELETE_BOOKMARK_SUCCESS });

      if (addToast) {
        addToast("Removed from bookmarks", {
          appearance: "success",
          autoDismiss: true,
        });
      }

      // Refetch bookmarks to refresh the list, maintaining current page
      const { bookmarkData } = getState();
      const currentPage = bookmarkData.pagination?.page || 1;
      dispatch(fetchBookmarks(currentPage));
    } catch (error) {
      console.error("Error deleting bookmark:", error);
      dispatch({
        type: DELETE_BOOKMARK_FAILURE,
        payload: error.message,
      });

      if (addToast) {
        addToast("Failed to remove bookmark", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    }
  };
};

export const clearBookmarks = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_BOOKMARKS });
  };
};
